<script>
export default {
    name: "AutopsyReport",

    data() {

        return {
            autopsyReport: {},
            patient: {},
        };
    },

    mounted() {
        this.$root.loading=true;
        Promise.allSettled([ 
            this.fetchAutopsyReport(), this.fetchPatient(), 
        ]).then(() => {
            this.$root.loading=false;
            setTimeout(() => {
                window.print();
            }, 250);
        }).catch(() => { this.$root.loading=false; });
    },

    methods: {

        fetchPatient() {
            let url = `PatientRegistration/GetSpecificPatient`;

            return this.$http.get(`${url}?PatientID=${this.$route.query.PatientID}`).then(response => {
                this.patient = response.data.length ? response.data[0] : {};
            }).catch(() => {});
        },

        fetchAutopsyReport() {

            return this.$http.get(`Morgue/GetAutopsyReport?PatientID=${this.$route.query.PatientID}`)
                .then(response => {
                    this.autopsyReport = response.data;
                }).catch(() => {});
        },
    },
}
</script>
<template>
    <div class="flex flex-wrap mx-2">
        <tail-address-header></tail-address-header>
        <div class="w-full flex flex-wrap my-2 border-b-2 border-t-2 border-gray-300 my-3">
            <div class="w-1/3 p-1">
                <h5 class="font-medium text-base">Patient: {{ patient.names }}</h5>
            </div>
            <div class="w-1/3 p-1">
                <h5 class="font-medium text-base">MRN : {{ patient.patienT_ID }}</h5>
            </div>
            <div class="w-1/3 p-1">
                <h5 class="font-medium text-base">IP File No: {{ patient.ipfileno || `-` }}</h5>
            </div>
            <div class="w-1/3 p-1">
                <h5 class="font-medium text-base">OP File No: {{ patient.opfileno || `-` }}</h5>
            </div>
            <div class="w-1/3 p-1">
                <h5 class="font-medium text-base">Visit No: {{ patient.visitNo }}</h5>
            </div>
        </div>
        <table class="table text-base">
            <thead>
                <tr>
                    <th class="p-tiny">Bed</th>
                    <th class="p-tiny">Date Admitted</th>
                    <th class="p-tiny">Autopsy Date</th>
                    <th class="p-tiny">Header</th>
                    <th class="p-tiny">Ref</th>
                    <th class="p-tiny">Details</th>
                    <th class="p-tiny">Comment</th>
                    <th class="p-tiny">Done By</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(auto,idx) in autopsyReport" :key="idx">
                    <td class="p-tiny">{{ auto.bed }}</td>
                    <td class="p-tiny">{{ auto.date_Admitted | dateFormat }}</td>
                    <td class="p-tiny">{{ auto.autopsy_Date | dateFormat }}</td>
                    <td class="p-tiny">{{ auto.header }}</td>
                    <td class="p-tiny">{{ auto.ref }}</td>
                    <td class="p-tiny">{{ auto.details }}</td>
                    <td class="p-tiny">{{ auto.comment }}</td>
                    <td class="p-tiny">{{ auto.doneBy }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>